import { PENDING_APPOINTMENT_CANCELLATION_REASON } from './errorReasons';
import { PendingCancellationErrorBody, UnassignJobAffectedAppointments } from './types';

export class UnassignMutationError extends Error {
  constructor(
    message: string,
    readonly type: string | undefined,
    readonly affectedAppointments?: UnassignJobAffectedAppointments
  ) {
    super(message);
  }

  static isPendingAppointmentsCancellationErrorBody(error: unknown): error is PendingCancellationErrorBody {
    if (typeof error !== 'object' || error === null) {
      return false;
    }

    const { reason, affectedAppointments } = error as Record<string, unknown>;
    if (reason !== PENDING_APPOINTMENT_CANCELLATION_REASON) {
      return false;
    }

    if (typeof affectedAppointments !== 'object' || affectedAppointments === null) {
      return false;
    }

    const { appointments } = affectedAppointments as Record<string, unknown>;
    return typeof appointments === 'number';
  }
}
